module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_HERZKREISLAUF.56afb1a6.png";